import { Navigate, useLocation, useParams } from "react-router-dom";

export const StylesToModelsRedirect = () => {
  const { workspace, "*": splatPath } = useParams();
  const location = useLocation();

  const remainingPath = splatPath ? `/${splatPath}` : "";
  const newPath = `/${workspace}/models${remainingPath}`;

  return (
    <Navigate to={`${newPath}${location.search}${location.hash}`} replace />
  );
};
